import { NgModule } from '@angular/core';
import { AgmSnazzyInfoWindow } from './directives/snazzy-info-window';

@NgModule({
  declarations: [AgmSnazzyInfoWindow],
  exports: [AgmSnazzyInfoWindow],
})
export class AgmSnazzyInfoWindowModule {}
